import React, { useEffect, useState } from "react";
import "./SelectUser.css";
import { Animation } from "../../../../components";
import useSelectUser from "./SelectUser.hooks";
import { FormattedMessage } from "react-intl";
import CustomToolTip from "../../../../components/CustomToolTip/CustomToolTip";
export default function SelectUser({
  selectSeats,
  plan,
  withoutSelectButton,
  usersAndCredits,
  selectedUser,
  setSelectedUser,
}) {
  const [toggle, setToggle] = useState(false);
  const handleSelectSeats = (users) => {
    selectSeats(users.users);
    setSelectedUser(users);
  };

  let allowCollapse = plan.planId !== "0";
  return (
    <div
      id={"select-credits"}
      style={plan.planId == "0" ? { opacity: 0.3, pointerEvents: "none" } : {}}
    >
      <div className={"select-user-container dropdown"}>
        {!withoutSelectButton && (
          <button className={"users"} onClick={() => setToggle(true)}>
            <FormattedMessage id={"billing.userSelect"} />
          </button>
        )}

        <span
          className={"credits dropdown-toggle "}
          onClick={() => setToggle(true)}
        >
          <span style={{ paddingRight: 10, paddingLeft: 10, fontSize: 14 }}>
            <span className={"n-credits"}>
              {!withoutSelectButton && (
                <img src="/assets/images/user-vector.svg" alt="" />
              )}{" "}
              {plan.numberOfSeats}{" "}
            </span>{" "}
            <FormattedMessage id={selectedUser.users == 1 ? "user" : "users"} />
          </span>
        </span>

        {toggle && allowCollapse && (
          <Animation.SlideDown
            setToggle={setToggle}
            toggle={toggle}
            className={"dropdown-menu show"}
            style={{
              minWidth: "max-content",
              left: 50,
              right: -50,
              marginTop: 5,
              overflow: "hidden",
            }}
            heightSize={400}
          >
            <ul className={"select-users-list"}>
              {usersAndCredits.map((users) => (
                <li
                  onClick={() => {
                    handleSelectSeats(users);
                    setToggle(false);
                  }}
                >
                  {users.users}{" "}
                  {users.users == 1 ? (
                    <FormattedMessage id={"user"} />
                  ) : (
                    <FormattedMessage id={"users"} />
                  )}
                  {plan.currentSeats > 1 && plan.currentSeats == users.users && (
                    <small style={{ marginLeft: 5 }}>
                      {" "}
                      <FormattedMessage id={"current"} />
                    </small>
                  )}
                </li>
              ))}
            </ul>
          </Animation.SlideDown>
        )}
      </div>
    </div>
  );
}
